import axios from 'axios';
import LocalStorage from 'local-storage';

let _CurrentLoggedInUser = null;
let _UserToken = '';
let _IsReDirect = '0';
class AppCache {
    constructor() {
        this.sessionTimeout = 20 * 60 * 1000;
        this.sessionTimer = null;
        this.activityEvents = ['mousedown', 'mousemove', 'keypress', 'scroll'];

        this.startSessionTimer = () => {
            this.sessionTimer = setTimeout(this.clearStorage, this.sessionTimeout);
        };

        this.resetSessionTimer = () => {
            clearTimeout(this.sessionTimer);
            this.startSessionTimer();
        };

        this.clearStorage = () => {
            console.log('Session expired');
            _CurrentLoggedInUser = null;
            LocalStorage.clear();
            window.location.href = '/login';
        };


        this.handleUserActivity = () => {
            this.resetSessionTimer();
        };
        this.activityEvents.forEach(event => {
            document.addEventListener(event, this.handleUserActivity);
        });
        this.startSessionTimer();


        const sessionKey = 'uniqueSessionId';
        if (localStorage.getItem(sessionKey)) {
            clearStorageAndRedirect();
        } else {
            localStorage.setItem(sessionKey, Date.now().toString());
        }

        function clearStorageAndRedirect() {
            localStorage.removeItem(sessionKey);

            // Regex patterns for dynamic paths
            const distributorPattern = /^\/DistributorClaimApproval\/[^/]+\/\d+$/;
            const emailApprovalPattern = /^\/ContractClaimApproval\/[^/]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\/\d+$/;

            if (
                !distributorPattern.test(window.location.pathname) &&
                !emailApprovalPattern.test(window.location.pathname) &&
                window.location.pathname !== '/login'
            ) {
                window.location.href = '/login';
            }
        }
        this.RemoveItemFromLocalStorage = () => {

            LocalStorage.remove("_IsReDirect")
        }

        this.GetIsRedirect = () => {
            _IsReDirect = LocalStorage.get("_IsReDirect");
            if (_IsReDirect === null)
                _IsReDirect = '0'
            return _IsReDirect;
        };

        this.SetIsRedirect = (IsRedirect) => {
            _IsReDirect = IsRedirect;
            LocalStorage.set("_IsReDirect", _IsReDirect);
        }
        this.GetCurrentLoggedInUser = () => {
            if (_CurrentLoggedInUser === null)
                _CurrentLoggedInUser = LocalStorage.get("_CurrentLoggedInUser");
            return _CurrentLoggedInUser;
        };


        this.SetCurrentLoggedInUser = (token) => {
            const CurrentLoggedInUser = {
                Token: token
            }

            _CurrentLoggedInUser = CurrentLoggedInUser;

            LocalStorage.set("_CurrentLoggedInUser", _CurrentLoggedInUser);
            _UserToken = token;
            LocalStorage.set("_UserToken", _UserToken);


            axios.defaults.headers.common.authheader = _UserToken;
            axios.defaults.headers.common['Content-Type'] = 'application/json';
        };

    }
}

export default new AppCache();